import { createFileRoute, redirect } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { ensureWorkspaces } from '@/lib/api/resolve-workspaces'
import { requireAuth } from '@/lib/auth-guard'
import { orgLandingTarget, chooserDirectStores } from '@/lib/org-landing'
import { WorkspaceSelectPage } from '@/modules/shared/components/workspace-select-page'

export const Route = createFileRoute('/select')({
  beforeLoad: async ({ context }) => {
    await requireAuth()

    const { queryClient } = context as { queryClient: QueryClient }
    const workspaces = await ensureWorkspaces(queryClient)
    // Unambiguous destination: never show the chooser (mirrors /welcome's bounce).
    const target = orgLandingTarget(workspaces)
    if (target.to !== '/select') throw redirect(target)
    return { workspaces, stores: chooserDirectStores(workspaces) }
  },
  component: WorkspaceSelectPage,
})
